import axios from 'axios';
import config from '@/config';
import qs from 'qs';
import store from '@/store';

const axiosInstance = axios.create();

const request = async ({ action, options }) => {
  if (location.href.indexOf('localhost') > -1 && options) {
    options.from_local = 1;
  }

  const headers = {};

  const user = store.state.user;

  if (user) {
    if (user.login) headers['X-USER-LOGIN'] = user.login;
    if (user.token) headers['X-USER-TOKEN'] = user.token;
  }

  if (action !== 'get_tele2_number') {
    return await axiosInstance.post(
      (config.production ? '' : config.hostname) + '/api/api.php?action=' + action,
      qs.stringify(options),
      { headers }
    );
  } else {
    return await axiosInstance.post(
      config.hostname.replace('https', 'http') + '/__promo/index.php'
    );
  }
};

export default request;
